import CustomSelect from '../../../../customComponents/CustomSelect'
import CustomTextField from '../../../../customComponents/CustomTextField'

export const MobileCheckOutNewAddress = ({ formData, handleInputChange, countriesList, statesList, districtList, errors }) => {
	return (
		<div className='accordion-body text-sm opacity-8'>
			<div className='row mb-3'>
				<div className='col-md-6'>
					<CustomTextField
						name='name'
						placeholder='Enter Full Name'
						label='Full Name'
						value={formData?.name}
						type='text'
						onChange={handleInputChange}
						maxLength={50}
						charType={'text'}
						error={errors?.name}
					/>
				</div>
				<div className='col-md-6'>
					<CustomSelect
						name='countryId'
						value={formData?.countryId}
						placeholder='--Please Choose--'
						label='Select Country'
						onChange={handleInputChange}
						options={countriesList}
					/>
				</div>
			</div>
			<div className='row mb-3'>
				<div className='col-md-4'>
					<CustomSelect
						name='stateId'
						value={formData.stateId}
						onChange={handleInputChange}
						placeholder='Select State'
						label='Select State'
						options={statesList}
					/>
				</div>
				<div className='col-md-4'>
					<CustomSelect
						name='districtId'
						value={formData.districtId}
						onChange={handleInputChange}
						placeholder='Select District'
						label='Select District'
						options={districtList}
					/>
				</div>
				<div className='col-md-4'>
					<CustomTextField
						name='city'
						value={formData.city}
						type='text'
						onChange={handleInputChange}
						placeholder='City'
						label='City'
						maxLength={15}
						error={errors?.city}
						disabled={!formData.stateId || !formData.countryId || !formData.stateId}
					/>
				</div>
			</div>
			<div className='row mb-3'>
				<div className='col-md-6 '>
					<div className='equal-width'>
						<CustomTextField
							type='number'
							name='mobileNo'
							placeholder='Enter Mobile Number'
							label='Mobile Number'
							value={formData.mobileNo}
							onChange={handleInputChange}
							maxLength={10}
							error={errors?.mobileNo}
						/>
					</div>
				</div>
				<div className='col-md-6'>
					<CustomTextField
						type='email'
						name='emailId'
						placeholder='Enter Email Address'
						label='Email ID'
						value={formData.emailId}
						onChange={handleInputChange}
						maxLength={40}
						error={errors?.emailId}
					/>
				</div>
			</div>

			<div className='row mb-3'>
				<div className='col-md-6'>
					<CustomTextField
						name='addressLine1'
						value={formData.addressLine1}
						type='text'
						onChange={handleInputChange}
						placeholder='Address Line 1'
						label='Enter Address Line 1'
						maxLength={50}
						error={errors?.addressLine1}
					/>
				</div>
				<div className='col-md-6'>
					<CustomTextField
						name='addressLine2'
						placeholder='Address Line 2'
						label='Enter Address Line 2'
						type='text'
						value={formData.addressLine2}
						onChange={handleInputChange}
						error={errors?.addressLine2}
						maxLength={50}
					/>
				</div>
			</div>
			<div className='row mb-3'>
				<div className='col-md-6'>
					<CustomTextField
						name='landmark'
						placeholder='Landmark (optional)'
						label='Landmark'
						type='text'
						value={formData.landmark}
						onChange={handleInputChange}
						maxLength={30}
						error={errors?.landmark}
					/>
				</div>

				<div className='col-md-6'>
					<div className='equal-width'>
						<CustomTextField
							type='number'
							name='zipCode'
							placeholder='Pincode'
							label='Pincode'
							maxLength={6}
							value={formData.zipCode}
							onChange={handleInputChange}
							error={errors?.zipCode}
						/>
					</div>
				</div>
			</div>
		</div>
	)
}
